const initState = {
    getByIdDonwload:{
        buffer:"",
        result:false,
        /**control */
        connection: false,
        error: false,
        message: "",
    },
};

export default initState;